exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".event .panel {\n  padding: 2rem 1rem; }\n\n.event .title {\n  font-weight: bold; }\n\n.event .location {\n  color: #2455a5;\n  margin-bottom: 0.5rem; }\n\n.event .description {\n  color: #898a8e;\n  margin-bottom: 1rem; }\n\n.file-input {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/show-event/show-event.component.scss
// module id = 388
// module chunks = 0